import getTimeAttemptedForAudioTranscription from "./getTimeAttemptedForAudioTranscription";

const fetchTranscribeAudio = async (
  mp3File,
  examGuid,
  route,
  userData,
  ExamAttemptId,
  displayAuthenticationError
) => {
  const formData = new FormData();
  formData.append(examGuid, mp3File);

  return await fetch(`${route}/transcribeaudio.webapi`, {
    method: "POST",
    headers: {
      TOKEN: userData.Token,
      ExamGuid: examGuid,
      ExamAttemptId: ExamAttemptId,
      LastModified: getTimeAttemptedForAudioTranscription(examGuid),
    },
    body: formData,
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else if (response.status === 401) {
        displayAuthenticationError();
        throw new Error("User is no longer authenticated");
      } else {
        throw new Error("Error fetching transcription");
      }
    })
    .then((result) => {
      return { id: result.response_id, transcription: result.Transcription };
    });
};

export default fetchTranscribeAudio;
